import ScrollAnimation from './ScrollAnimation';
import Parallax from './Parallax';

let scrollAnimationInstances = [];
let parallaxAnimationInstances = [];

const initScrollAnimations = () => {
  let scrollAnimationItems = document.getElementsByClassName('scroll-animation');
  for (let scrollAnimationItem of scrollAnimationItems) {
    let scrollAnimationInstance = new ScrollAnimation(scrollAnimationItem);
    scrollAnimationInstance.setScrollPosition(window.pageYOffset || document.documentElement.scrollTop);
    scrollAnimationInstances.push(scrollAnimationInstance);
  }
}

const initParallax = () => { 
  let parallaxAnimationItems = document.getElementsByClassName('parallax-animation');
  for (let parallaxAnimationItem of parallaxAnimationItems) { 
    let parallaxAnimationInstance = new Parallax(parallaxAnimationItem);
    parallaxAnimationInstance.setScrollPosition(window.pageYOffset || document.documentElement.scrollTop);
    parallaxAnimationInstances.push(parallaxAnimationInstance);
  }
}

window.addEventListener('scroll', () => {
  for(let scrollAnimationInstance of scrollAnimationInstances) {
    scrollAnimationInstance.setScrollPosition(window.pageYOffset || document.documentElement.scrollTop);
  }

  for(let parallaxAnimationInstance  of parallaxAnimationInstances) {
    parallaxAnimationInstance.setScrollPosition(window.pageYOffset || document.documentElement.scrollTop);
  }
});

initParallax();
initScrollAnimations();


// WEBPACK FOOTER //
// ./ui/assets/js/ScrollAnimation/init.js